import * as types from '../constants/actionTypes';
import editProfileService from '../services/editProfileService';
import { generateParamsUpdateProfile } from '../functions/utils';
import { updateProfile, updateUserInfo } from './loginActions';
import { PROFILE_MEMBER_TYPE } from '../constants/constants';
import * as myStore from '../store/myStore';

const configApp = require('../../app');

const isNative = !configApp || !configApp.isWebApp;

export function resetLoadedStatusPhotoAndGeneralData() {
  return { type: types.RESET_STATUS_LOADED_PHOTO_AND_DATA };
}

export function getUserGallerieSuccess(data: any) {
  return { type: types.GET_GALLERIES_SUCCESS, data };
}

export function getUserGalleryRequest() {
  return { type: types.GET_GALLERIES_REQUEST };
}

export function getUserPhotoRequest() {
  return { type: types.GET_USER_PHOTO_REQUEST };
}

export function setLoadedGeneralAllDetail() {
  return { type: types.SET_LOADED_ALL_GENERAL_DETAILS_SUCCESS };
}

export function getUserPhotoSuccess(data: any) {
  return { type: types.GET_USER_PHOTO_SUCCESS, data };
}

export function getUserProfilePhotoSuccess(data: any) {
  return { type: types.GET_USER_PROFILE_PHOTO_SUCCESS, data };
}

export function getPropertyProfileBuilderSuccess(data: any, key: any) {
  return { type: types.GET_PROPERTY_PROFILE_BUILDER, data, key };
}

export function getPropertySuccess(data: any, key: any, userInfo: any) {
  return { type: types.GET_PROPERTY_SUCCESS, data, key, userInfo };
}

export function getInterestPropertySuccess(data: any, key: any, userInfo: any) {
  return { type: types.GET_INTEREST_PROPERTY_SUCCESS, data, key, userInfo };
}

export function patchUpdateUserPhotoSuccess(galleryId: any, move: any, photoId: any, image: any, currentGalleryId: any) {
  return {
    type: types.PATCH_UPDATE_USER_PHOTO_SUCCESS,
    galleryId,
    move,
    photoId,
    image,
    currentGalleryId,
  };
}

export function uploadPhotoSuccess(galleryId: any, photo: any) {
  return { type: types.UPLOAD_PHOTO_SUCCESS, galleryId, photo };
}

export function resetUserPhoto() {
  return { type: types.RESET_USER_PHOTO };
}

export function postVerificationSuccess() {
  return { type: types.POST_VERIFICATION_SUCCESS };
}

export function updateEditProfileState(params: any) {
  return { type: types.UPDATE_EDIT_PROFILE_STATE, params };
}

export function updateStateEditProfile(dataKey: any, data: any) {
  return { type: types.UPDATE_STATE_EDIT_PROFILE_WITH_KEY, dataKey, data };
}

export function getUserGalleries() {
  return (dispatch: any) => {
    dispatch(getUserGalleryRequest());
    return editProfileService.getPhotoGallery().then((res: any) => {
      if (res && res.success) {
        dispatch(getUserGallerieSuccess(res.data));
      } else {
        console.log('ERROR: editProfileActions/getUserPhoto', res.message);
      }
      return res;
    });
  };
}

export function getUserPhoto() {
  return (dispatch: any) => {
    dispatch(resetUserPhoto());
    dispatch(getUserPhotoRequest());
    dispatch(getUserGalleryRequest());
    return editProfileService.getPhotoGallery().then((res: any) => {
      if (res && res.success) {
        dispatch(getUserGallerieSuccess(res.data));
        return editProfileService.getUserPhotos({}).then((res: any) => {
          if (res && res.success) {
            // dispatch update profile
            dispatch(getUserPhotoSuccess(res.data));
          } else {
            console.log('ERROR: editProfileActions/getUserPhoto', res.message);
          }
          return res;
        });
      }
      console.log('ERROR: editProfileActions/getUserPhoto', res.message);

      return res;
    });
  };
}

export function gerUserRestrictedPhoto() {
  return (dispatch: any) => {
    const params = {
      UserPhotoDisplay: 'RestrictedBB',
      GalleryType: 'Public',
    };
    return editProfileService.getUserPhotos(params).then((res: any) => {
      // if (res && res.success) {
      // } else {
      //   console.log('ERROR: editProfileActions/gerUserRestrictedPhoto', res.message);
      // }
      return res;
    });
  };
}

export function patchUpdateUserPhoto(params: any) {
  // params
  //  photoID
  //  move
  //  galleryID
  // generate params
  /*
   * PhotoIDs query int[] No List of photo ID to be effected by the action. // [0]
   * Action query PhotoAction No Sets the action type, options are Move and Delete. 'Move' || 'Delete'
   * GalleryIDquery int? No For Move action, the destination GalleryID needs to be set. // 0
   * */
  return (dispatch: any) => {
    const body = {
      PhotoIDs: params.photoID,
      Action: params.move ? 'Move' : 'Delete',
      GalleryID: params.move && params.galleryID ? params.galleryID : 0,
    };
    dispatch(patchUpdateUserPhotoSuccess(params.galleryID, params.move, params.photoID, params.image, params.currentGalleryId));
    return editProfileService.patchUpdateUserPhoto(body).then(() => {
      // if (res.success) {
      //   // dispatch update user photo success
      // } else {
      //   console.warn(
      //     "ERROR: editProfileActions/patchUpdateUserPhoto",
      //     res.message
      //   );
      // }
      return { success: true };
    });
  };
}

export function updateUserProfile(params: any) {
  // params
  //  photoID
  //  move
  //  galleryID
  // generate params
  /*
   * PhotoIDs query int[] No List of photo ID to be effected by the action. // [0]
   * Action query PhotoAction No Sets the action type, options are Move and Delete. 'Move' || 'Delete'
   * GalleryID query int? No For Move action, the destination GalleryID needs to be set. // 0
   * */
  const updateProfileData: { params: any; pramsKey: any } = generateParamsUpdateProfile(params);
  return (dispatch: any) => {
    const body = {
      DetailInfo: updateProfileData.params,
    }; //

    // const body = {
    //   PhotoIDs:params.photoID,
    //   Action:params.move ? 'Move' : 'Delete',
    //   GalleryID:params.move && params.galleryID ? params.galleryID : 0
    // };
    // dispatch(patchUpdateUserPhotoSuccess(params.galleryID,params.move,params.photoID, params.image,params.currentGalleryId))
    return editProfileService.updateUserProfile(body).then((res: any) => {
      if (res && res.success) {
        let userInfo = myStore.getStore().getState().loginReducer.userInfo;
        let updateData = Object.fromEntries(Object.entries(updateProfileData.params).map(([k, v]) => [updateProfileData.pramsKey[k], v]));
        userInfo = {
          ...userInfo,
          detailInfo: { ...userInfo.detailInfo, ...updateData },
          locationInfo: res.data.locationInfo,
          location: res.data.location,
          tempInfo: res.data.tempInfo,
        };
        dispatch(updateUserInfo(userInfo));
      } else {
        console.warn('ERROR: editProfileActions/updateUserProfile', res.message);
      }
      return res;
    });
  };
}

export function uploadUserPhoto(params: any, buildVersion?: string) {
  const file = isNative
    ? {
        uri: params.imagePath,
        name: params.name,
        type: params.type,
      }
    : params.file;
  const { galleryId } = params;
  const formData = new FormData();
  isNative ? formData.append('File', file) : formData.append('File', file);
  formData.append('GalleryID', galleryId);
  formData.append('Type', 'Gallery');
  // GalleryID body int No
  // Urls body string[] No
  // Type body PhotoUploadType No // "Gallery"
  // RotateAngle body ImageRotateAngle? No // "Rotate90"
  // RotateDirection body ImageRotateDirection? No "Right"
  return (dispatch: any) => {
    return editProfileService.uploadUserPhoto(formData).then((res: any) => {
      if (res && res.success) {
        // console.log(res.data)
        dispatch(uploadPhotoSuccess(galleryId, res.data));
        if (params && params.isUpdateProfile) {
          dispatch(updateProfile(buildVersion));
        }
        // dispatch update uploadPhoto Success
      } else {
        console.log('ERROR: editProfileActions/uploadUserPhoto', res.message);
      }
      return res;
    });
  };
}

//
export function getLookUpMaritalStatus(params: any) {
  return (dispatch: any, getState: any) => {
    // const userInfo = getState().loginReducer.userInfo;
    return editProfileService.getLookUpMaritalStatus().then((res: any) => {
      if (res && res.success) {
        // params:  {maritalStatus: 0  value(int) }
        dispatch(getPropertySuccess(res.data, 'maritalStatus', params));
        // dispatch action
      } else {
        console.log('ERROR: editProfileActions/getLookUpMaritalStatus', res.message);
      }
      return res;
    });
  };
}

//
export function getLookUpSexual(params: any) {
  return (dispatch: any) => {
    return editProfileService.getLookUpSexual().then((res: any) => {
      if (res && res.success) {
        // console.log('sexual', res.data)
        dispatch(getPropertySuccess(res.data, 'sexualOrientation', params));
        // dispatch action
      } else {
        console.log('ERROR: editProfileActions/getLookUpSexual', res.message);
      }
      return res;
    });
  };
}

export function getLookUpRace(params: any) {
  return (dispatch: any) => {
    return editProfileService.getLookUpRace().then((res: any) => {
      if (res && res.success) {
        // console.log('race', res.data)

        dispatch(getPropertySuccess(res.data, 'race', params));
        // dispatch action
      } else {
        console.log('ERROR: editProfileActions/getLookUpRace', res.message);
      }
      return res;
    });
  };
}

export function getLookUpPersonality(params: any) {
  return (dispatch: any) => {
    return editProfileService.getLookUpPersonality().then((res: any) => {
      if (res && res.success) {
        // console.log('personality', res.data)

        dispatch(getPropertySuccess(res.data, 'personality', params));
        // dispatch action
      } else {
        console.log('ERROR: editProfileActions/getLookUpPersonality', res.message);
      }
      return res;
    });
  };
}

export function getLookUpMyLooks(params: any) {
  return (dispatch: any) => {
    return editProfileService.getLookUpMyLooks().then((res: any) => {
      if (res && res.success) {
        // console.log('myLooks', res.data)

        dispatch(getPropertySuccess(res.data, 'myLooks', params));
        // dispatch action
      } else {
        console.log('ERROR: editProfileActions/getLookUpMyLooks', res.message);
      }
      return res;
    });
  };
}

export function getLookUpBodyType(params: any) {
  return (dispatch: any) => {
    return editProfileService.getLookUpBodyType().then((res: any) => {
      if (res && res.success) {
        // console.log('bodyType', res.data)

        dispatch(getPropertySuccess(res.data, 'bodyType', params));
        // dispatch action
      } else {
        console.log('ERROR: editProfileActions/getLookUpBodyType', res.message);
      }
      return res;
    });
  };
}

export function getLookUpHeightCm(params: any) {
  return (dispatch: any) => {
    return editProfileService.getLookUpHeightCm().then((res: any) => {
      if (res && res.success) {
        // console.log('heightCm', res.data)

        dispatch(getPropertySuccess(res.data, 'height', params));
        // dispatch action
      } else {
        console.log('ERROR: editProfileActions/getLookUpHeight', res.message);
      }
      return res;
    });
  };
}

export function getLookUpEyeColour(params: any) {
  return (dispatch: any) => {
    return editProfileService.getLookUpEyeColour().then((res: any) => {
      if (res && res.success) {
        // console.log('eyeColour', res.data)

        dispatch(getPropertySuccess(res.data, 'eyeColour', params));
        // dispatch action
      } else {
        console.log('ERROR: editProfileActions/getLookUpEyeColour', res.message);
      }
      return res;
    });
  };
}

export function getLookUpHairColour(params: any) {
  return (dispatch: any) => {
    return editProfileService.getLookUpHairColour().then((res: any) => {
      if (res && res.success) {
        // console.log('hairColour', res.data)

        dispatch(getPropertySuccess(res.data, 'hairColour', params));
        // dispatch action
      } else {
        console.log('ERROR: editProfileActions/getLookUpHairColour', res.message);
      }
      return res;
    });
  };
}

export function getLookUpHairLength(params: any) {
  return (dispatch: any) => {
    return editProfileService.getLookUpHairLength().then((res: any) => {
      if (res && res.success) {
        // console.log('hairLength', res.data)

        dispatch(getPropertySuccess(res.data, 'hairLength', params));
        // dispatch action
      } else {
        console.log('ERROR: editProfileActions/getLookUpHairLength', res.message);
      }
      return res;
    });
  };
}

export function getLookUpDrinking(params: any) {
  return (dispatch: any) => {
    return editProfileService.getLookUpDrinking().then((res: any) => {
      if (res && res.success) {
        dispatch(getPropertySuccess(res.data, 'drinking', params));
        // dispatch action
      } else {
        console.log('ERROR: editProfileActions/getLookUpDrinking', res.message);
      }
      return res;
    });
  };
}

export function getLookUpSmoking(params: any) {
  return (dispatch: any) => {
    return editProfileService.getLookUpSmoking().then((res: any) => {
      if (res && res.success) {
        // console.log('smoking', res.data)

        dispatch(getPropertySuccess(res.data, 'smoking', params));
        // dispatch action
      } else {
        console.log('ERROR: editProfileActions/getLookUpSmoking', res.message);
      }
      return res;
    });
  };
}

// Intimate Info
export function getLookUpSafeSex(params: any) {
  return (dispatch: any) => {
    return editProfileService.getLookUpSafeSex().then((res: any) => {
      if (res && res.success) {
        // console.log('safeSex', res.data)

        dispatch(getPropertySuccess(res.data, 'safeSex', params));
        // dispatch action
      } else {
        console.log('ERROR: editProfileActions/getLookUpSafeSex', res.message);
      }
      return res;
    });
  };
}

export function getLookUpBodyHair(params: any) {
  return (dispatch: any) => {
    return editProfileService.getLookUpBodyHair().then((res: any) => {
      if (res && res.success) {
        // console.log('safeSex', res.data)

        dispatch(getPropertySuccess(res.data, 'bodyHair', params));
        // dispatch action
      } else {
        console.log('ERROR: editProfileActions/getLookUpSafeSex', res.message);
      }
      return res;
    });
  };
}

export function getLookUpPubicHair(params: any) {
  return (dispatch: any) => {
    return editProfileService.getLookUpPubicHair().then((res: any) => {
      if (res && res.success) {
        // console.log('safeSex', res.data)

        dispatch(getPropertySuccess(res.data, 'pubicHair', params));
        // dispatch action
      } else {
        console.log('ERROR: editProfileActions/getLookUpSafeSex', res.message);
      }
      return res;
    });
  };
}

export function getLookUpEndowmentLength(params: any) {
  return (dispatch: any) => {
    return editProfileService.getLookUpEndowmentLength().then((res: any) => {
      if (res && res.success) {
        //  console.log('endowmentLength', res.data)

        dispatch(getPropertySuccess(res.data, 'endowmentLength', params));
        // dispatch action
      } else {
        console.log('ERROR: editProfileActions/getLookUpEndowmentLength', res.message);
      }
      return res;
    });
  };
}

export function getLookUpEndowmentThickness(params: any) {
  return (dispatch: any) => {
    return editProfileService.getLookUpEndowmentThickness().then((res: any) => {
      if (res && res.success) {
        // console.log('endowmentThickness', res.data)

        dispatch(getPropertySuccess(res.data, 'endowmentThickness', params));
        // dispatch action
      } else {
        console.log('ERROR: editProfileActions/getLookUpEndowmentThickness', res.message);
      }
      return res;
    });
  };
}

export function getLookUpIntimatePiercing(params: any) {
  return (dispatch: any) => {
    return editProfileService.getLookUpIntimatePiercing().then((res: any) => {
      if (res && res.success) {
        //  console.log('intimatePiercing', res.data)

        dispatch(getPropertySuccess(res.data, 'intimatePiercing', params));
        // dispatch action
      } else {
        console.log('ERROR: editProfileActions/getLookUpIntimatePiercing', res.message);
      }
      return res;
    });
  };
}

export function getLookUpSexualPersonality(params: any) {
  return (dispatch: any) => {
    return editProfileService.getLookUpSexualPersonality().then((res: any) => {
      if (res && res.success) {
        // console.log('sexualPersonality', res.data)

        dispatch(getPropertySuccess(res.data, 'sexualPersonality', params));
        // dispatch action
      } else {
        console.log('ERROR: editProfileActions/getLookUpSexualPersonality', res.message);
      }
      return res;
    });
  };
}

//
export function getLookUpSexualInterestSingle(params: any) {
  return (dispatch: any) => {
    return editProfileService.getLookUpSexualInterestSingle().then((res: any) => {
      if (res && res.success) {
        //  console.log('generalInterest', res.data)

        dispatch(getInterestPropertySuccess(res.data, 'sexualInterestSingle', params));
        // dispatch action
      } else {
        console.log('ERROR: editProfileActions/getLookUpGeneralInterest', res.message);
      }
      return res;
    });
  };
}

export function getLookUpSexualInterestCouple(params: any) {
  return (dispatch: any) => {
    return editProfileService.getLookUpSexualInterestCouple().then((res: any) => {
      if (res && res.success) {
        dispatch(getInterestPropertySuccess(res.data, 'sexualInterestCouple', params));
        // dispatch action
      } else {
        console.log('ERROR: editProfileActions/getLookUpGeneralInterest', res.message);
      }
      return res;
    });
  };
}

export function getLookUpGeneralInterest(params: any) {
  return (dispatch: any) => {
    return editProfileService.getLookUpGeneralInterest().then((res: any) => {
      if (res && res.success) {
        //  console.log('generalInterest', res.data)

        dispatch(getInterestPropertySuccess(res.data, 'generalInterest', params));
        // dispatch action
      } else {
        console.log('ERROR: editProfileActions/getLookUpGeneralInterest', res.message);
      }
      return res;
    });
  };
}

export function getLookUpFetishInterest(params: any) {
  return (dispatch: any) => {
    return editProfileService.getLookUpFetishInterest().then((res: any) => {
      if (res && res.success) {
        // console.log('fetishInterest', res.data)

        dispatch(getInterestPropertySuccess(res.data, 'fetishInterest', params));
        // dispatch action
      } else {
        console.log('ERROR: editProfileActions/getLookUpFetishInterest', res.message);
      }
      return res;
    });
  };
}

//
export function getProfileBuilderPersonality() {
  return (dispatch: any) => {
    return editProfileService.getProfileBuilderPersonality().then((res: any) => {
      if (res && res.success) {
        // console.log('fetishInterest', res.data)
        dispatch(getPropertyProfileBuilderSuccess(res.data, 'profileBuilderPersonality'));
        // dispatch action
      } else {
        console.log('ERROR: editProfileActions/getProfileBuilderPersonality', res.message);
      }
      return res;
    });
  };
}

export function getProfileBuilderLooks() {
  return (dispatch: any) => {
    return editProfileService.getProfileBuilderLooks().then((res: any) => {
      if (res && res.success) {
        // console.log('fetishInterest', res.data)
        dispatch(getPropertyProfileBuilderSuccess(res.data, 'profileBuilderLooks'));
        // dispatch action
      } else {
        console.log('ERROR: editProfileActions/getProfileBuilderLooks', res.message);
      }
      return res;
    });
  };
}

export function getProfileBuilderInterest() {
  return (dispatch: any) => {
    return editProfileService.getProfileBuilderInterest().then((res: any) => {
      if (res && res.success) {
        // console.log('fetishInterest', res.data)
        dispatch(getPropertyProfileBuilderSuccess(res.data, 'profileBuilderInterest'));
        // dispatch action
      } else {
        console.log('ERROR: editProfileActions/getProfileBuilderInterest', res.message);
      }
      return res;
    });
  };
}

export function getProfileBuilderSeeking() {
  return (dispatch: any) => {
    return editProfileService.getProfileBuilderSeeking().then((res: any) => {
      if (res && res.success) {
        // console.log('fetishInterest', res.data)
        dispatch(getPropertyProfileBuilderSuccess(res.data, 'profileBuilderSeeking'));
        // dispatch action
      } else {
        console.log('ERROR: editProfileActions/getProfileBuilderSeeking', res.message);
      }
      return res;
    });
  };
}

// Participation
export function getLookUpParticipation(params: any) {
  return (dispatch: any) => {
    return editProfileService.getLookUpParticipation().then((res: any) => {
      if (res && res.success) {
        // console.log('safeSex', res.data)

        dispatch(getPropertySuccess(res.data, 'participation', params));
        // dispatch action
      } else {
        console.log('ERROR: editProfileActions/getLookUpParticipation', res.message);
      }
      return res;
    });
  };
}

// Intention
export function getLookUpIntention(params: any) {
  return (dispatch: any) => {
    return editProfileService.getLookUpIntention().then((res: any) => {
      if (res && res.success) {
        // console.log('safeSex', res.data)

        dispatch(getInterestPropertySuccess(res.data, 'intention', params));
        // dispatch action
      } else {
        console.log('ERROR: editProfileActions/getLookUpIntention', res.message);
      }
      return res;
    });
  };
}

export function getLookUpDealBreaker(params: any) {
  return (dispatch: any) => {
    return editProfileService.getLookUpIntention().then((res: any) => {
      if (res && res.success) {
        dispatch(getInterestPropertySuccess(res.data, 'dealBreaker', params));
        // dispatch action
      } else {
        console.log('ERROR: editProfileActions/getLookUpDealBreaker', res.message);
      }
      return res;
    });
  };
}

// Intention
export function getVerificationInfo() {
  return (dispatch: any) => {
    return editProfileService.getVerificationInfo().then((res: any) => {
      return res;
    });
  };
}

// get all Lookup Datas
export function getLookupDatas(params: any) {
  return (dispatch: any) => {
    return editProfileService.getLookupDatas().then((res: any) => {
      if (res.success && res.data) {
        Object.keys(params).forEach(key => {
          switch (key) {
            case 'fetishInterest':
            case 'sexualInterestSingle':
            case 'sexualInterestCouple':
            case 'generalInterest':
            case 'intention':
            case 'dealBreaker':
              dispatch(getInterestPropertySuccess(res.data[key], key, params[key]));
              break;
            case 'profileBuilderSeeking':
            case 'profileBuilderPersonality':
            case 'profileBuilderLooks':
            case 'profileBuilderInterest':
              dispatch(getPropertyProfileBuilderSuccess(res.data[key], key));
              break;
            case 'seekingRelationshipStatus':
              dispatch(getPropertySuccess(res.data[key], key, params[key]));
              break;
            default:
              dispatch(getPropertySuccess(res.data[key], key, params[key]));
              break;
          }
        });
      } else {
        console.log('ERROR: editProfileActions/getLookUpSexual', res.message);
      }
      return res;
    });
  };
}

export function postVerificationInfo(params: any) {
  let objFile = {
    uri: params.imagePath,
    name: 'images',
    type: 'image/jpg',
  };
  if (params.file) {
    objFile = params.file;
  }
  const formData = new FormData();
  formData.append('items', objFile as any);
  return (dispatch: any) => {
    return editProfileService.postVerificationInfo(formData).then((res: any) => {
      if (res.success) {
        dispatch(postVerificationSuccess());
      }
      return res;
    });
  };
}

export function makeUserMainPhoto(photoId: any) {
  return (dispatch: any) => {
    return editProfileService.makeUserMainPhoto(photoId).then((res: any) => {
      if (res.success) {
        return res;
      }
      return res;
    });
  };
}

/**
 * @param params: { memberTypeId: number }
 */
export function patchUserMemberType(params: any) {
  const updateParams = {
    Type: (PROFILE_MEMBER_TYPE as any)[params.memberTypeId],
  };
  return (dispatch: any) => {
    return editProfileService.patchUserMemberType(updateParams).then((res: any) => {
      if (res.success) {
        return res;
      }
      return res;
    });
  };
}
